import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import {
	Container,
	Detail,
	DetailLabel,
	DetailValue,
} from './styles'

const BuildingDetail = props => (
	<Detail>
		<DetailLabel>{props.label}</DetailLabel>
		{props.value.map((value, index) => <DetailValue key={value + index}>{value}</DetailValue>)}
	</Detail>
)

BuildingDetail.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.string,
	]),
}

const Details = props => {
	const { t } = props;
	const spaceTypes = props.spaceTypes
		.filter(s => s !== '') // Filter out empty values
		.filter((type, index) => props.spaceTypes.findIndex(t => t === type) === index) // Filter out duplicates
		.map(type => t('space-type/' + type)); // Map to localized text

	return (
		<Container>
			<BuildingDetail label={t('building/details/Floors')} value={[props.floors]} />
			<BuildingDetail label={t('building/details/Area')} value={[props.totalArea]} />
			<BuildingDetail label={t('building/details/Space types')} value={spaceTypes} />
			<BuildingDetail label={t('building/details/Contact', { count: props.contacts.length })} value={props.contacts} />
		</Container>
	)
}

Details.propTypes = {
	t: PropTypes.func,
	floors: PropTypes.string,
	totalArea: PropTypes.string,
	spaceTypes: PropTypes.array,
	contacts: PropTypes.array,

}

export default translate('translations')(Details);
